export function makeStateContainer(initialState) {
    var state = initialState;
    var listeners = [];
    return {
        getState: function () {
            return state;
        },
        updateState: function (updater) {
            state =
                typeof updater === 'function'
                    ? updater(state)
                    : updater;
            for (var _i = 0, listeners_1 = listeners; _i < listeners_1.length; _i++) {
                var listener = listeners_1[_i];
                listener(state);
            }
        },
        subscribe: function (listenerFn) {
            listeners.push(listenerFn);
            return function unsubscribe() {
                listeners = listeners.filter(function (l) { return l !== listenerFn; });
            };
        }
    };
}
//# sourceMappingURL=stateContainer.js.map